/**
 * The required files for cost-to-serve analysis that the user must provide in step one of configuration.
 */
export const c2sFileMap = {
  ArtifactFiles: [
    {
      id: "layersConfiguration",
      title: "Layers Configuration",
      file: "layers_configuration.json",
    },
    {
      id: "bom",
      title: "Bill of Materials",
      file: "bom.csv",
    },
    {
      id: "costBreakdown",
      title: "Cost Breakdown",
      file: "cost_breakdown.csv",
    },
    {
      id: "spliceTables",
      title: "Splice Tables",
      file: "splice_table.csv",
    },
  ],
} as const;

/**
 * Groups the artifact files into the sections shown on the Artifacts step.
 */
export const getC2sFileSections = (isSpliceViewEnabled: boolean): { key: string; title: string; ids: string[] }[] => [
  { key: "required", title: "Required input files", ids: ["layersConfiguration"] },
  {
    key: "costToServe",
    title: `${isSpliceViewEnabled ? "(Optional) " : ""}Required input files for cost to serve`,
    ids: ["bom", "costBreakdown"],
  },
  { key: "spliceView", title: "(Optional) Required input files for splice view", ids: ["spliceTables"] },
];
